var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"license-info",on:{"click":_vm.toPage}},[_c('span',[_vm._v("证照信息")])])}
var staticRenderFns = []

export { render, staticRenderFns }